import React, { useContext } from "react";
import { FormBuilderContext, ACTIONS } from "../context/context";
import { brandSelect } from "../resources/brandList";
import BrandSelect from "../components/BrandSelect";

const BrandSelectGroup = () => {
    const { state, dispatch } = useContext(FormBuilderContext);

    const handleFormBrandSelectChange = (event) => {
        dispatch({
          type: ACTIONS.FORM_BRAND_SELECT,
          payload: event.target.value,
        });
    };



    return (
        <>
            <h2 className="section-subheader">Select a Brand</h2>
            <div className="input-group-wrapper">
                <div className="form-builder-section-div">
                    {/* <p>Font Family</p> */}
                    <BrandSelect
                        selectedBrand={state.selectedBrand}
                        onFormBrandSelectChange={handleFormBrandSelectChange}
                    />
                </div>
            </div>
        </>
    );
};

export default BrandSelectGroup;
